import React from "react"
import style from "./pool-safety-notice.mod.scss"

// NZ pool safety notice, required on spa and swim spa product and category
// pages from 29 September 2026. The warning wording is the official
// Label A / Label B text and must not be edited.
const GUIDE_PATH =
  "/learn/spa-pool-regulations-new-zealand-rules-requirements-more/"

const BUILDING_LINE =
  "For more information visit www.building.govt.nz/poolsafety"
const WATER_SAFETY_URL = "https://www.watersafetynz.org"

const notices = {
  "spa-pools": {
    heading: "Spa Pool Safety",
    intro:
      "We make and sell spas, so we take water safety seriously. Under the Building Act 2004, every spa pool that holds 40cm or more of water needs a barrier that keeps unsupervised children under 5 out. Most spa pools can use a compliant lockable cover, while larger spas need a fence. Plan your barrier before your spa arrives.",
    guideText: "Read our guide to spa pool regulations and fencing in NZ",
    // Label A
    label: (
      <>
        <p>
          To keep your family safe and prevent drowning, this pool requires a
          barrier, such as a:
        </p>
        <ul>
          <li>
            Fence or barrier to surround the entire pool, such as a 1.2m high
            fence; or
          </li>
          <li>
            Safety Cover that covers the pool. A safety cover may ONLY be used
            if the top surface of every pool wall is at least 760mm above the
            ground AND the walls of the pool inhibit climbing (e.g. there are no
            fixed objects or projections or a side-mounted pump).
          </li>
        </ul>
        <p>
          The barrier must comply with the Building Code and restrict
          unsupervised access by children under 5 years of age.
        </p>
      </>
    )
  },
  "swim-spas": {
    heading: "Swim Spa Safety",
    intro:
      "We make and sell swim spas, so we take water safety seriously. Under the Building Act 2004, every swim spa that holds 40cm or more of water needs a barrier that keeps unsupervised children under 5 out. For a swim spa, that means a fence. Plan your fence before your swim spa arrives.",
    guideText: "Read our guide to swim spa regulations and fencing in NZ",
    // Label B
    label: (
      <p>
        To keep your family safe and prevent drowning, this pool requires a
        barrier to surround the entire pool, such as a 1.2m high fence. The
        barrier must comply with the Building Code and restrict unsupervised
        access by children under 5 years of age.
      </p>
    )
  }
}

const PoolSafetyNotice = ({ categorySlug }) => {
  if (process.env.GATSBY_LANGUAGE !== "en-NZ") return null

  const notice = notices[categorySlug]
  if (!notice) return null

  return (
    <section className={style.safety}>
      <div className={style.safety__inner}>
        <h2 className={style.safety__heading}>{notice.heading}</h2>
        <p className={style.safety__intro}>{notice.intro}</p>
        <div className={style.safety__label}>
          <h3>WARNING: CHILDREN MAY DROWN IN THIS POOL.</h3>
          {notice.label}
          <p>{BUILDING_LINE}</p>
          <p>
            For more information on how to keep safe in the water visit:{" "}
            <a
              href={WATER_SAFETY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {WATER_SAFETY_URL}
            </a>
          </p>
        </div>
        <a
          href={GUIDE_PATH}
          className={style.safety__link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {notice.guideText} <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  )
}

export default PoolSafetyNotice
